var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 80,
    viewBox: "0 0 47 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1907_45",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 47,
    height: 80
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 80,
    rx: 4,
    fill: "#EFF3FF",
    fillOpacity: 0.8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1907_45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8203 40.69L33.639 37.7717L38.4578 40.69C38.7293 40.871 38.9894 40.871 39.2383 40.69C39.4872 40.509 39.5663 40.2602 39.4758 39.9434L38.1863 34.4462L42.3942 30.7813C42.6205 30.5551 42.6997 30.3176 42.6318 30.0687C42.5639 29.8199 42.3716 29.6728 42.0549 29.6276L36.4896 29.1525L34.2499 23.9946C34.1594 23.7231 33.9558 23.5873 33.639 23.5873C33.3223 23.5873 33.1187 23.7231 33.0282 23.9946L30.7885 29.1525L25.2232 29.6276C24.9064 29.6728 24.7141 29.8199 24.6463 30.0687C24.5784 30.3176 24.6576 30.5551 24.8838 30.7813L29.0917 34.4462L27.8022 39.9434C27.7117 40.2602 27.7909 40.509 28.0398 40.69C28.2886 40.871 28.5488 40.871 28.8203 40.69ZM18.7077 53.7206C17.2145 53.7206 15.9363 53.1889 14.873 52.1257C13.8097 51.0624 13.2781 49.7842 13.2781 48.2912V18.4294C13.2781 16.9363 13.8097 15.6581 14.873 14.5949C15.9363 13.5316 17.2145 13 18.7077 13H48.5704C50.0635 13 51.3418 13.5316 52.4051 14.5949C53.4684 15.6581 54 16.9363 54 18.4294V48.2912C54 49.7842 53.4684 51.0624 52.4051 52.1257C51.3418 53.1889 50.0635 53.7206 48.5704 53.7206H18.7077ZM18.7077 48.2912H48.5704V18.4294H18.7077V48.2912ZM9.74883 66.9548C8.25569 67.1357 6.90961 66.7738 5.71057 65.8689C4.51154 64.964 3.82153 63.765 3.64054 62.2719L0.0434367 32.6137C-0.13755 31.1207 0.247046 29.7859 1.19722 28.6096C2.1474 27.4332 3.36906 26.7319 4.8622 26.5057H4.99794C5.76713 26.3699 6.45714 26.5735 7.06797 27.1165C7.6788 27.6594 7.98421 28.3381 7.98421 29.1525C7.98421 29.8312 7.74667 30.4194 7.27158 30.9171C6.79649 31.4147 6.2196 31.7315 5.5409 31.8672H5.47303L9.138 61.5932L41.3083 57.6569C42.0775 57.5664 42.7562 57.7474 43.3444 58.1998C43.9326 58.6523 44.272 59.2631 44.3625 60.0323C44.453 60.8014 44.272 61.4688 43.8195 62.0344C43.367 62.5999 42.7562 62.9279 41.987 63.0184L9.74883 66.9548Z",
    fill: "#423ED8",
    fillOpacity: 0.14
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.6d11df8cd32bc698a8a8cc791b717527.svg";
export { ForwardRef as ReactComponent };